// extracted by mini-css-extract-plugin
export default {"closeBtn":"close-button_closeBtn__HNDKe"};